export const deviceRoutes = [
  {
    component: () => import('@/domains/device/pages/IndexPage.vue'),
    meta: {
      anyPerm: [],
      requiresAuth: true,
    },
    name: 'devices',
    path: '/devices',
  },
  {
    component: () => import('@/domains/device/pages/DetailPage.vue'),
    meta: {
      requiresAuth: true,
    },
    name: 'devices-detail',
    path: '/devices/:id/edit',
  },
]
